module.exports = __webpack_public_path__ + "static/media/VMS.cb453958.png";